import { useTypedSelector } from 'src/State/RootReducer'
import { useHagerBridgePermissions } from '../../shared/hooks/use-hager-bridge-permissions'

export const useShouldShowEMobilityTourBanner = (): boolean => {
  const tourRunning = useTypedSelector(state => state.eMobility.tour.isRunning)
  const tourCompleted = useTypedSelector(state => state.eMobility.tour.isCompleted)
  const {
    permissions: { tourGuidePermissions },
  } = useHagerBridgePermissions()

  return !tourRunning && !tourCompleted && tourGuidePermissions.viewTourGuide
}
